import {PropsWithChildren} from "react";
import {Header} from "./Header";
import {Box} from "@mui/material";

export interface AppLayoutProps extends PropsWithChildren {
    sidePanel?: React.ReactNode;
    header?: React.ReactNode;
    rightPanel?: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({sidePanel, header, children, rightPanel}) => {
    return (
        <Box sx={{height: "100vh"}}>
            {header ?? <Header />}
            <Box sx={{display: "flex", height: "calc(100vh - 56px)"}}>
                <Box sx={{display: "flex", width: "100%", height: "100%"}}>
                    {sidePanel && (
                        <Box
                            sx={{
                                flex: "none",
                                width: "20rem",
                                minWidth: "20rem",
                                backgroundColor: "white",
                            }}
                        >
                            {sidePanel}
                        </Box>
                    )}
                    <Box
                        sx={{
                            flex: "1 1 auto",
                            backgroundColor: "#EDEEF6",
                            overflowX: "hidden",
                            overflowY: "auto",
                        }}
                    >
                        {children}
                    </Box>
                    {rightPanel && rightPanel}
                </Box>
            </Box>
        </Box>
    );
};
